import Cookies from 'js-cookie'
import config from '../config'

export const getPaymentById = async (id) => {
  const { data, status } = await fetch(`${config.apiAdminGateway}/api/v2/admin/payments/${id}`, {
    headers: {
      Authorization: `Bearer ${Cookies.get('accessToken')}`,
    },
  }).then((res) => res.json())

  if (status.code !== 0) throw new Error(status.description)

  return data
}

export const postWithdrawPayment = async (userId, amount) => {
  const { data, status } = await fetch(`${config.apiAdminGateway}/api/v2/admin/payments/withdraw`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${Cookies.get('accessToken')}`,
    },
    body: JSON.stringify({ userId, amount }),
  }).then((res) => res.json())

  if (status.code !== 0) throw new Error(status.description)

  return data
}
